import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import UtilService from './services/util';

// Desabilita completamente o webpack-dev-server overlay (iframe modal)
if (typeof window !== 'undefined') {
  // Desabilita React Error Overlay
  window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__ = { 
    isDisabled: true,
    onBuildError: () => {},
    onBuildOk: () => {},
    onError: () => {}
  };

  // Remove qualquer iframe de overlay do webpack-dev-server
  const removeWebpackOverlay = () => {
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    if (overlay) {
      overlay.remove();
    }
  };

  // Intercepta a criação de overlays
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.id === 'webpack-dev-server-client-overlay') {
          node.remove();
        }
      });
    });
  });

  // Inicia observação quando DOM carregar
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, { childList: true, subtree: true });
      removeWebpackOverlay();
    });
  } else {
    observer.observe(document.body, { childList: true, subtree: true });
    removeWebpackOverlay();
  }

  // Remove overlay a cada 100ms (garantia extra)
  setInterval(removeWebpackOverlay, 100);
}

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
UtilService.reportWebVitals();
